(() => {
  const root = document.querySelector('[data-orabio-confirmation]');
  if (!root || root.dataset.started) return;
  root.dataset.started = 'true';
  const title = root.querySelector('.c1-title'), message = root.querySelector('.c1-message');
  const hash = new URLSearchParams(location.hash.slice(1));
  let session;
  try { session = JSON.parse(sessionStorage.getItem('orabio.checkout.v4') || 'null'); } catch {}
  const id = hash.get('orabio') || session?.id, token = hash.get('token') || session?.token;
  const show = (a,b) => { title.textContent = a; message.textContent = b; };
  if (!/^[a-f0-9-]{36}$/.test(id || '') || !/^[a-f0-9]{64}$/.test(token || '')) {
    show('Order status unavailable','Open the confirmation link from your checkout or contact support with your payment receipt.'); return;
  }
  // Remove the capability from the address bar after saving it locally for refresh.
  try {
    sessionStorage.setItem('orabio.checkout.v4', JSON.stringify({ ...(session || {}), id, token }));
    if (hash.has('token')) history.replaceState(null,'',location.pathname + location.search);
  } catch {}
  let attempts = 0, stopped = false;
  async function clearMatchingCart() {
    if (!session?.cartHash) return;
    const cart = await (await fetch('/cart.js',{cache:'no-store',credentials:'same-origin'})).json();
    const shape = JSON.stringify([cart.currency,cart.total_price,cart.attributes,
      cart.items.map(i=>[i.key,i.quantity,i.final_line_price]).sort((a,b)=>String(a[0]).localeCompare(String(b[0])))]);
    const digest = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(shape)))).map(x=>x.toString(16).padStart(2,'0')).join('');
    if (digest !== session.cartHash) return;
    await fetch('/cart/clear.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:'{}'});
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  window.addEventListener('pagehide', () => { stopped = true; }, { once:true });
  async function check() {
    if (stopped) return;
    try {
      const r = await fetch('https://orabio-checkout-bridg-production.up.railway.app/api/checkout/status', {
        method:'POST', headers:{'Content-Type':'application/json'}, credentials:'omit', cache:'no-store',
        body:JSON.stringify({id,token}), signal:AbortSignal.timeout(15000)
      });
      if (!r.ok) throw new Error('Unavailable');
      const s = await r.json();
      root.querySelector('[data-order-reference]').textContent = `Reference: ${s.reference}`;
      if (s.state === 'complete') {
        show('Thank you!', `Your payment is confirmed. Your order ${s.orderName || ''} has been created.`);
        root.querySelectorAll('.c1-step').forEach(x => x.classList.add('is-complete'));
        await clearMatchingCart().catch(()=>{});
        try { sessionStorage.setItem('orabio.checkout.v4',JSON.stringify({id,token,complete:true})); } catch {}
        return;
      }
      if (s.state === 'review') {
        show(s.paid ? 'Payment received' : 'We are checking your checkout', 'Please contact support with the reference below. Do not pay again while we check your order.'); return;
      }
      show(s.paid ? 'Payment received' : 'Checking your payment…', s.paid ? 'We are creating your order. This page will update automatically.' : 'We are waiting for confirmation from Whop. If you have paid, please do not pay again.');
    } catch { show('Checking your order','The connection is taking longer than expected. We will try again automatically.'); }
    if (++attempts < 60) setTimeout(check,5000);
    else show('Confirmation is taking longer','You can refresh this page later. If you have paid, do not pay again; contact support with your receipt.');
  }
  check();
})();
